import { HeaderComponent } from './header.component';

export default HeaderComponent;
